import axios from "axios";
import routes from "../app/routes";

export const teamTopicActions = {
  loadTopics: (dispatch, team) => {
    axios.get(routes.api.teams.topics(team.id)).then((resp) => {
      dispatch({ type: "loadTopics", topics: resp.data.data });
    });
  },
  assignTopic: (dispatch, team, topicId, successCallback) => {
    axios
      .post(routes.api.teams.assign_topic(team.id), {
        topic_id: topicId,
      })
      .then((resp) => {
        successCallback();
      });
  },
  removeTopic: (dispatch, team, topicId, successCallback) => {
    axios
      .post(routes.api.teams.remove_topic(team.id), {
        topic_id: topicId,
      })
      .then((resp) => {
        successCallback();
      });
  },
};
